import { Col, Row } from 'antd';
import Image from 'next/image';
import styled from 'styled-components';

import CuriousCuriLogoForButton from '../../assets/icons/CuriosCuriLogoForButton';
import Curiconbanner from '../../assets/images/curicon2023.png';
import CuriconLogo from '../../assets/images/curiconlogo.png';
import theme from '../../assets/theme';
import { useIsMobile } from '../../hooks/useIsMobile';
import { useMarketingMetrics } from '../../providers/PlausibleAnalyticsProvider';
import { IconWrapper } from '../_atoms/IconWrapper';
import MaxWidthContainer from '../_atoms/MaxWidthContainer';
import { CenteredContainer } from '../styled/CenteredContainer';

const CuriconHeader = () => {
  const ismobile = useIsMobile();
  const { track } = useMarketingMetrics();
  return (
    <MaxWidthContainer>
      <HeadlineContainer $ismobile={ismobile}>
        <Col xs={24} md={12} lg={12} xl={12} xxl={12} style={{ padding: '40px 20px' }}>
          <Image
            style={{ objectFit: 'contain' }}
            alt="the Curipod team"
            height={CuriconLogo.height}
            width={CuriconLogo.width}
            src={CuriconLogo.src}
          />
          <HeaderParagraph>
            Join us for Curicon, your passport to a week of transformative educational
            experiences at the intersection of Artificial Intelligence (AI) and innovative
            teaching methods.
          </HeaderParagraph>
          <HeaderParagraph>Click to register for our free virtual event!</HeaderParagraph>
          <CenteredContainer>
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSdHZtW5mD04ZIjcDCqN0zPWAhw1MQnJgEuXaaZMF5-1wpGhjg/viewform"
              onClick={() => track('curicon-register')}
            >
              <Cuributton role="button">
                <IconWrapper
                  height="60px"
                  width="60px"
                  style={{ position: 'absolute', top: -10, left: -10 }}
                >
                  <CuriousCuriLogoForButton />
                </IconWrapper>
                <span style={{ whiteSpace: 'nowrap' }}>Register now</span>
              </Cuributton>
            </a>
            <a
              href="https://curi-con.com/"
              style={{
                fontWeight: 'bold',
                color: 'white',
                marginLeft: 20,
                textDecoration: 'underline',
              }}
            >
              See the amazing speakers!
            </a>
          </CenteredContainer>
        </Col>
        <Col xs={24} md={12} lg={12} xl={12} xxl={12} style={{ padding: '40px 20px' }}>
          <Image
            style={{ objectFit: 'contain' }}
            alt="Curicon banner"
            height={Curiconbanner.height}
            width={Curiconbanner.width}
            src={Curiconbanner.src}
          />
        </Col>
      </HeadlineContainer>
    </MaxWidthContainer>
  );
};

const HeaderParagraph = styled.p`
  color: white;
  font-size: 18px;
  text-align: left;
  margin-bottom: 0px;
  padding-bottom: 20px;

  @media (max-width: 1128px) {
  }
`;

export default CuriconHeader;

const HeadlineContainer = styled(Row)<{ $ismobile: boolean }>`
  align-items: center;
  @media (max-width: 800px) {
    padding-bottom: 40px;
  }
`;

const Cuributton = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background: ${theme.colors.orange};
  border-radius: 100px;
  box-shadow: 0px 5px 0px #ef7c23;
  color: white;
  font-weight: bold;
  font-size: 18px;
  max-width: 300px;
  padding: 5px 20px 5px 45px;
  cursor: pointer;
  &:hover {
    box-shadow: 0px 2px 0px #ef7c23;
  }
`;
